var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertAnnotationSeverityWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#FFF6D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5257 6.01554C14.7957 4.66149 12.9531 4.66149 12.2229 6.01554L6.25342 17.0854C5.52883 18.4289 6.44443 20.1008 7.90488 20.1008H19.8438C21.3042 20.1008 22.2199 18.4289 21.4954 17.0854L15.5257 6.01554Z",
    fill: "#DCA101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0636 11.0312C15.0636 10.3355 14.5314 9.77148 13.8748 9.77148C13.2183 9.77148 12.686 10.3355 12.686 11.0312V13.0467C12.686 13.7425 13.2183 14.3064 13.8748 14.3064C14.5314 14.3064 15.0636 13.7425 15.0636 13.0467V11.0312ZM13.8748 18.3375C14.5314 18.3375 15.0636 17.7734 15.0636 17.0778C15.0636 16.382 14.5314 15.8181 13.8748 15.8181C13.2183 15.8181 12.686 16.382 12.686 17.0778C12.686 17.7734 13.2183 18.3375 13.8748 18.3375Z",
    fill: "#FFF6D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertAnnotationSeverityWarning);
export default __webpack_public_path__ + "static/media/AlertAnnotationSeverityWarning.72e176cfaab25a27bf109ffebdd8eea5.svg";
export { ForwardRef as ReactComponent };